import styled from "styled-components";

export const AccordionWrapper = styled.div`
  border-bottom: ${({ $borderBottom }) => $borderBottom || "1.5px solid #dde2ea"};
  background: ${({ $bg }) => $bg || "#fff"};
  transition: background 0.15s ease;
  box-shadow: ${({ $shadow }) => $shadow || "none"};
  margin-bottom: ${({ $mb }) => $mb || "0"};
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: stretch;
  cursor: pointer;
  user-select: none;
`;

export const ChevronCell = styled.div`
  width: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChevronCircle = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1.5px solid
    ${({ $expanded }) => ($expanded ? "var(--accent-2)" : "var(--rule)")};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: ${({ $expanded }) =>
    $expanded ? "var(--accent-3)" : "transparent"};
  transform: ${({ $expanded }) =>
    $expanded ? "rotate(180deg)" : "rotate(0deg)"};
`;
